import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row } from 'react-bootstrap';
import { messages as jobmessages } from '../views/Job/Job.messages';
import useI18n from "../hooks/useI18n";
import { nanoid } from "nanoid";
import isEmpty from 'lodash.isempty';

const InvoiceDetails = (props) => {
    const lng = props.intl.formatMessage;
    const { getCountry } = useI18n();
    const country = getCountry();

    /**
     * Return the account details based on the account type.
     * 
     * @param {*} i 
     * @param {*} accountType 
     * @param {*} account 
     * @returns account details
     */
    const showAccountDetails = (i, accountType, account) => {
        switch (accountType) {
            case 'bankgirot':
                return (
                    <li key={`invoice-bankgirot-${i}`}>
                        <span className='label'>{lng(jobmessages.bankgirot)}</span>
                        <span className='float-end'>{account.bankgirot}</span>
                    </li>
                );
            case 'bban':
                return (
                    <li key={`invoice-bban-${i}`}>
                        <span className='label'>{lng(jobmessages.bban)}</span>
                        <span className='float-end'>{account.bban}</span>
                    </li>
                );
            default:
                return (
                    <>
                        <li id={`invoice-iban-${i}`} key={`invoice-iban-${i}`}>
                            <span className='label'>{lng(jobmessages.iban)}</span>
                            <span className='float-end'>{account.iban}</span>
                        </li>
                        <li id={`invoice-bic-${i}`} key={`invoice-bic-${i}`}>
                            <span className='label'>{lng(jobmessages.bic)}</span>
                            <span className='float-end'>{account.bic}</span>
                        </li>
                        {account.virtualbarcode && (
                            <li id={`invoice-virtualbarcode-${i}`} key={`invoice-virtualbarcode-${i}`} className='d-flex'>
                                <span className='col-6 col-md-5 col-xxl-3 label'>{lng(jobmessages.virtualbarcode)}</span>
                                <span className='col-6 col-md-7 col-xxl-9 float-end text-end text-break align-items-end'>{account.virtualbarcode}</span>
                            </li>
                        )}
                    </>
                );
        }
    };

    /**
     * Return account owner name and possible addon text when available.
     * 
     * @param {*} i 
     * @param {*} account 
     * @returns account owner name (and addon text)
     */
    const showAccountOwner = (i, account) => {
        if (isEmpty(account.owner)) {
            return null;
        }
        
        return (
            <li id={`invoice-account-owner-${i}`} key={`invoice-account-owner-${i}`} className='d-flex'>
                <span className='col-6 col-md-5 col-xxl-3 label'>{lng(jobmessages.accountOwnerName)}</span>
                <span className='col-6 col-md-7 col-xxl-9 float-end text-end text-break align-items-end'>{account.owner}
                    <br />
                    <span className='small'>{account.addon_text}</span>
                </span>
            </li>
        )
    }

    /**
     * Check what account types should be shown and render them.
     * 
     * @returns accounts or null
     */
    const renderBankInformation = () => {
        if (props.job?.accounts) {
            return props.job.accounts.map((account, i) => {
                let accountType = 'iban';
                if (country === 'se' && account?.bankgirot) {
                    accountType = 'bankgirot';
                } else if (country === 'no' && account?.bban) {
                    accountType = 'bban';
                }
                return (
                    <React.Fragment key={`invoice-account-${nanoid()}`}>
                        {showAccountDetails(i, accountType, account)}
                        {showAccountOwner(i, account)}
                    </React.Fragment>
                )
            });
        }

        return null;
    }

    // invoice details
    return (
        <Card className="fullwidth-mobile grey-bottom-border-mobile">
            <Card.Body>
                <Row>
                    <h3 id="heading-invoice-details-title">{lng(jobmessages.invoiceOverview)}</h3>
                    <ul className='list-unstyled'>
                        <li id='invoice-reference' key={`invoice-reference-${props.job.jobid}`}>
                            <span className='label'>{lng(jobmessages.reference)}</span>
                            <span className='float-end'>{props.job.reference}</span>
                        </li>
                        <li id='invoice-billnum' key={`invoice-billnum-${props.job.jobid}`}>
                            <span className='label'>{lng(jobmessages.billNum)}</span>
                            <span className='float-end'>{props.job.billnum ? props.job.billnum : '-'}</span>
                        </li>
                        <li id='invoice-jobid' key={`invoice-jobid-${props.job.jobid}`}>
                            <span className='label'>{lng(jobmessages.jobid)}</span>
                            <span className='float-end'>{props.job.jobid}</span>
                        </li>
                        {renderBankInformation()}
                    </ul>
                </Row>
            </Card.Body>
        </Card>
    );
};

InvoiceDetails.propTypes = {
    'intl': PropTypes.object.isRequired,
    'job': PropTypes.object,
};

export default InvoiceDetails;